import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {push} from 'connected-react-router'
import styled from 'styled-components'
// Components
import { Layout, PrimaryButton, TextDetail } from '../components'
// Mui
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
// Reducks
import { updateSubscription } from '../reducks/users/operations'
import { getUserId, getUserEmail } from '../reducks/users/selectors'
import { db } from '../firebase'

const Subscription = () => {

    const dispatch = useDispatch()
    const selector = useSelector(state=>state)
    const email = getUserEmail(selector)
    const userId = getUserId(selector)

    const [isSubscribe, setIsSubscribe] = useState(false)

    useEffect(()=>{
        if(userId) {
            db.collection('users').doc(userId).get()
                .then(snapshot => {
                    const data = snapshot.data()
                    setIsSubscribe(data.is_subscribe)
                })
        }
    }, [userId])

    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign: 'center'}}>メールマガジン購読設定</h1>
            <div className='spacer-50' />

            <InputWrapper>
                <div>
                    <TextDetail label={'設定中のメールアドレス'} value={email} />
                </div>
                <SwitchWrapper>
                    <div>ストアからのメールマガジン</div>
                    <Switch
                        color="primary" checked={isSubscribe}
                        onChange={()=>setIsSubscribe(!isSubscribe)}
                    />
                </SwitchWrapper>
            </InputWrapper>

            <div className='spacer-50' />

            <div style={{textAlign: 'center'}}>
                <PrimaryButton label='保存する' operation={()=>dispatch(updateSubscription(userId, isSubscribe))} />
                <div className='spacer-25' />
                <Button onClick={()=>dispatch(push('/mypage'))}>マイページに戻る</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    )
}

export default Subscription

const InputWrapper = styled.div`
    width: 480px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`
const SwitchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`